import styled from "styled-components";
import { black } from "../../global/colours";
import { weight as fontWeight } from "../../global/fonts";

export const StyledTitle = styled.h2`
  color: ${black[100]};
  font-size: 10px;
  font-weight: ${({ weight = fontWeight.bold }) => weight};
  font-style: ${({ italic }) => (italic ? "italic" : "normal")};
  margin-bottom: 10px;
  background-color: ${({ highlight }) => (highlight ? "#FFF3A0" : "none")};
`;